export default __webpack_public_path__ + "static/IG88-ed668aa9e019184074fcf1fb310cfb81.jpeg";